import React from 'react';
import tw from 'twin.macro';
import Image from '~/src/atoms/Image';
import Link from '~/src/atoms/Link';
import Tags from '~/src/molecules/Tags/';
import LazyComponentLoader from '~/src/molecules/LazyComponent';
import Shimmer from '~/src/atoms/Shimmer';
import useSelectedPack from './useSelectedPack';
import URI from 'urijs';

const DeckImage = ({ imageAltText = '', listType, screenInPageContext, screenInPagePosition, screenItemName, screenItemPosition, ...rest }) => {
  const { images = [], availability = {}, additionalAttributes = {}, absoluteUrl = '' } = useSelectedPack();
  const type = additionalAttributes?.info?.find((value) => value?.type === 'food_type')?.label;
  const foodType = type === 'veg' ? 'veg' : 'nonVeg';

  const convertedAbsoluteUrl = URI(absoluteUrl);

  if (listType && listType !== 'ms') {
    convertedAbsoluteUrl.addQuery({ nc: listType });
  }

  if (listType === 'ms') {
    convertedAbsoluteUrl.addQuery({ nc: 'beforeyoucheckout' });
  }

  if (screenInPageContext) {
    convertedAbsoluteUrl.addQuery({ nc: screenInPageContext });
  }

  if (screenInPagePosition) {
    convertedAbsoluteUrl.addQuery({ t_pos_sec: screenInPagePosition });
  }

  if (screenItemPosition) {
    convertedAbsoluteUrl.addQuery({ t_pos_item: screenItemPosition });
  }

  if (screenItemName) {
    convertedAbsoluteUrl.addQuery({ t_s: screenItemName });
  }

  const available = () => {
    let status = 'In Stock';
    if (availability?.not_for_sale) {
      status = 'Not For Sale';
    } else if (availability?.avail_status === '000') {
      status = 'Out Of Stock';
    } else if (availability?.avail_status === '010') {
      status = 'Currently unavailable';
    }

    return (
      <div className="absolute top-0 left-0 z-10 p-5 flex items-center justify-center w-full h-full bg-white bg-opacity-50 rounded-xs">
        <Tags variant="oos" css={tw`xl:w-36.5 lg:w-full`}>
          {status}
        </Tags>
      </div>
    );
  };

  return (
    // eslint-disable-next-line react/no-unknown-property
    <div css={[tw`lg:p-5 xl:p-6  xl:w-60 xl:h-60  lg:w-48.5 lg:h-48.5 `]} {...rest}>
      <LazyComponentLoader fallback={<Shimmer css={tw`w-full h-full bg-silverSurfer-300 rounded-xs`} />}>
        <Link href={`${convertedAbsoluteUrl}`} target="_blank" rel="noopener noreferrer">
          <Image
            layout={'responsive'}
            width={154}
            height={154}
            src={images?.[0]?.imgM}
            alt={imageAltText}
            title={imageAltText}
            css={tw`box-border w-full h-full`}
            placeholder="blur"
            fallbackSrc={
              foodType === 'veg'
                ? `https://www.bbassets.com/bb2assets/images/png/veg-placeholder.png`
                : 'https://www.bbassets.com/bb2assets/images/png/non-veg-placeholder.png'
            }
            blurDataURL={`https://www.bbassets.com/bb2assets/images/png/veg-placeholder.png?tr=bl-56`}
          />
          {availability?.avail_status !== '001' && available()}
        </Link>
      </LazyComponentLoader>
    </div>
  );
};

export default DeckImage;
